import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=d19c29e6&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=ts&setup=true"
export * from "./Exchange.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=d19c29e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c29e6",
  null
  
)

export default component.exports